import { Component, Inject } from '@angular/core';
import { MAT_DIALOG_DATA, MatDialogRef } from '@angular/material/dialog';
import { TranslateService } from '@ngx-translate/core';
import { ToastrService } from 'ngx-toastr';
import { debounceTime, distinctUntilChanged, Subject, Subscription } from 'rxjs';
import { Organization } from 'src/app/models/organization';
import { User } from 'src/app/models/user';
import { AuthenticationService } from 'src/app/services/authentication.service';
import { OrganizationService } from 'src/app/services/organization.service';
import { TagService } from 'src/app/services/tag.service';

@Component({
  selector: 'app-create-tag-dialog',
  templateUrl: './create-tag-dialog.component.html',
  styleUrl: './create-tag-dialog.component.scss'
})
export class CreateTagDialogComponent {
  organization?: Organization;

  user?: User;

  mode: "create" | "edit" = "create";

  tagToCreate: {
    label?: string,
    description?: string
  } = {
      label: undefined,
      description: undefined
    };


  errors: {
    [key: string]: {
      value: boolean,
      message?: string
    }
  } = {
      label: {
        value: false,
        message: undefined
      }
    }

  private readonly labelSubject = new Subject<string>();
  private labelSubscription?: Subscription;


  constructor(
    @Inject(MAT_DIALOG_DATA) public data: any,
    private authService: AuthenticationService,
    private dialogRef: MatDialogRef<CreateTagDialogComponent>,
    private tagService: TagService,
    private translate: TranslateService
  ) {
    this.authService.user.subscribe((user: User | undefined) => {
      this.user = user;
    });
    this.labelSubscription = this.labelSubject
      .pipe(
        debounceTime(300),
        distinctUntilChanged()
      ).subscribe(async () => {
        await this.exists();
      });
  }

  ngOnInit(): void {
    this.organization = this.data.organization;
    if (this.data) {
      this.mode = this.data.mode;
      if (this.mode == 'edit') {
        this.tagToCreate = JSON.parse(JSON.stringify(this.data.tag));
      }
    }
  }

  ngOnDestroy(): void {
  }

  isDisabled() {
    return !this.tagToCreate.label || this.errors['label'].value;
  }

  onLabelChange(label: any) {
    if (typeof label == 'string') {
      this.labelSubject.next(label);
    }
  }


  _hasErrors() {
    this.errors['label'] = {
      value: false,
      message: undefined
    }
    if (!this.tagToCreate.label) {
      this.errors['label'].value = true;
      this.errors['label'].message = this.translate.instant('ERRORS.TAG_LABEL_REQUIRED');
    }


    return this.errors['label'].value;
  }

  async exists() {
    try {
      if (this.tagToCreate && this.tagToCreate.label && this.tagToCreate.label !== this.data.tag.label) {
        const { exists } = await this.tagService.exists(this.tagToCreate.label);
        if (exists) {
          this.errors['label'].value = true;
          this.errors['label'].message = this.translate.instant('ERRORS.TAG_LABEL_EXISTS');
        } else {
          this.errors['label'].value = false;
          this.errors['label'].message = undefined;
        }
      } else if (this.tagToCreate.label === this.data.tag.label) {
        this.errors['label'].value = false;
        this.errors['label'].message = undefined;
      }

    } catch (err) {
      console.log(err)
    }

  }

  onCancel(): void {
    this.dialogRef.close({
      created: false
    });
  }


  async onCreate() {
    if (this._hasErrors()) {
      return
    } else {
      this.dialogRef.close({
        created: true,
        tag: this.tagToCreate
      });
    }
  }

  async onEdit() {
    if (this._hasErrors()) {
      return
    } else {
      this.dialogRef.close({
        edited: true,
        tag: this.tagToCreate
      });
    }
  }

}
